import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { Container } from './Container';
import { costRows, timeCost } from '../data/landing';
export function CostOfInaction() {
  const {
    minutesPerNight,
    daysPerWeek,
    weeksPerYear
  } = timeCost;
  const hours = minutesPerNight * daysPerWeek * weeksPerYear / 60;
  const roundedHours = Math.floor(hours / 10) * 10;
  return <section aria-labelledby="cost-title" className="bg-white py-16 sm:py-20 lg:py-24" data-id="element-92" data-mp="34w01djgm6gn4">
      <Container data-id="element-93" data-mp="34u758y3mnetd">
        <h2 id="cost-title" className="mx-auto flex max-w-3xl flex-wrap items-center justify-center gap-x-3 gap-y-2 text-balance text-center font-heading text-[2rem] font-black leading-[1.1] text-navy sm:text-4xl" data-id="element-94" data-mp="38xdbi5qqp5zu">
          <ScaleIcon aria-hidden="true" className="h-8 w-8 text-teal" data-id="element-95" data-mp="3imwtl96movtn" />
          ¿Cuánto cuesta seguir improvisando?
        </h2>

        <div className="mx-auto mt-10 max-w-4xl overflow-hidden rounded-3xl border border-teal-soft bg-cream" data-id="element-96" data-mp="3nkojjxnpq7v7">
          <div className="hidden grid-cols-2 border-b border-teal-soft bg-white px-6 py-4 md:grid" data-id="element-97" data-mp="3eggc2dz3i2wq">
            <p className="font-heading text-sm font-extrabold uppercase tracking-wide text-navy-soft" data-id="element-98" data-mp="39hd5gp3gvomn">Sin sistema</p>
            <p className="font-heading text-sm font-extrabold uppercase tracking-wide text-pink" data-id="element-99" data-mp="34hqs8fnn28du">Lo que te cuesta</p>
          </div>

          <div className="grid gap-1 border-b border-teal-soft bg-pink-light/50 px-5 py-5 md:grid-cols-2 md:gap-6 md:px-6" data-id="element-100" data-mp="30i01ud20xu9u">
            <p className="text-base text-navy" data-id="element-101" data-mp="13nzhb1jiaeu">
              Si pensás y resolvés la vianda <strong data-id="element-102" data-mp="3s8ecm0eqqqha">{minutesPerNight} min por noche</strong> × {daysPerWeek} días × {weeksPerYear} semanas
            </p>
            <div data-id="element-103" data-mp="3nery02p0ociu">
              <p className="font-heading text-xl font-black text-pink sm:text-2xl" data-id="element-104" data-mp="3jfswks2huxw5">Más de {roundedHours} horas al año</p>
              <p className="mt-0.5 text-xs text-navy-soft" data-id="element-105" data-mp="jsb45sft0xrw">Ejemplo de cálculo con un supuesto, no una estadística.</p>
            </div>
          </div>

          <ul className="divide-y divide-teal-soft" data-id="element-106" data-mp="ez8a7j747mb6">
            {costRows.map(r => <li key={r.without} className="grid gap-1 px-5 py-4 md:grid-cols-2 md:gap-6 md:px-6" data-id="element-107" data-mp="299yj4va5f58b">
                <p className="font-heading text-base font-extrabold text-navy" data-id="element-108" data-mp="2e7i1o7dvq462">{r.without}</p>
                <p className="text-base text-navy-soft" data-id="element-109" data-mp="1zj3mcwza0n8m">{r.cost}</p>
              </li>)}
          </ul>
        </div>

        <p className="mt-12 text-center font-heading text-[1.75rem] font-black text-navy sm:text-[2.25rem]" data-id="element-110" data-mp="1qioxxor0ms0w">
          Mañana puede ser <span className="text-teal" data-id="element-111" data-mp="1vi1wv7v5vpju">diferente</span>.
        </p>
      </Container>
    </section>;
}